var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dueDate)?_c('chicklet',{attrs:{"color":_vm.dueDateColor,"size":_vm.size,"title":_vm.dueDateFormatted,"type":"transparent"}},[_c('span',[_vm._v(_vm._s(_vm.dueDateFormatted))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }